import { defineMessages } from 'react-intl';

export default defineMessages({
    anErrorOccurred: {
        id: 'quoteandbind.ho.wizard.error.cancel',
        defaultMessage: 'Something went wrong during this process.'
    },
    anErrorOccurredTitle: {
        id: 'quoteandbind.ho.wizard.error.cancel.title',
        defaultMessage: 'Error'
    },
    home: {
        id: 'quoteandbind.wizard.step.Home',
        defaultMessage: 'Home'
    },
    saveQuoteError: {
        id: 'quoteandbind.ho.wizard.Unable to quote',
        defaultMessage: 'Unable to quote'
    },
    saveQuoteErrorMessage: {
        id: 'quoteandbind.ho.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.'
    },
    packageDetails: {
        id: 'quoteandbind.ho.wizard.step.Package Details',
        defaultMessage: 'Package Details'
    },
    packageInfo: {
        id: 'quoteandbind.ho.wizard.step.Package Info',
        defaultMessage: 'Package Info'
    },
    riskAnalysis: {
        id: 'quoteandbind.ho.wizard.step.Risk Analysis',
        defaultMessage: 'Risk Analysis'
    },
});
